import { Modal, Text, Flex, Button } from '@mantine/core';
import { REPORT_TYPE_IDS } from '../../consts/v1/reportTypes';

export function UnsavedChangesModal({
  opened,
  onClose,
  onBack,
  onDiscard,
  onSaveChanges,
  isSaving = false,
  reportType
}) {
  const handleBack = () => {
    onBack?.();
    onClose?.();
  };

  const handleDiscard = () => {
    onDiscard?.();
    onClose?.();
  };

  const handleSave = () => {
    onSaveChanges?.();
    // Modal closes after save success via callback in ReportContainer
  };

  return (
    <Modal
      id="formpf-unsaved-changes-modal"
      opened={opened}
      onClose={handleBack}
      title={`Unsaved ${reportType === REPORT_TYPE_IDS.AIF002 ? 'Funds' : 'Manager'} Changes`}
      centered
      radius="sm"
      withCloseButton
      closeButtonProps={{ 'aria-label': 'Close' }}
      styles={{
        title: { fontSize: '16px', lineHeight: '22px', fontWeight: 600 }
      }}
    >
      <Text id="formpf-unsaved-changes-description" c="dimmed" fz="14px" lh="20px" mb="24px">
        You have made updates to this {reportType === REPORT_TYPE_IDS.AIF002 ? 'Funds' : 'Manager'}{' '}
        data.
        <br />
        Would you like to keep these changes before moving on?
      </Text>
      <Flex justify="space-between" align="center">
        <Button
          id="formpf-unsaved-changes-back-button"
          variant="subtle"
          color="gray"
          onClick={handleBack}
          disabled={isSaving}
        >
          Back
        </Button>
        <Flex gap="16px">
          <Button
            id="formpf-unsaved-changes-discard-button"
            variant="outline"
            color="gray"
            onClick={handleDiscard}
            disabled={isSaving}
          >
            Discard
          </Button>
          <Button id="formpf-unsaved-changes-save-button" onClick={handleSave} loading={isSaving}>
            Save Changes
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
}
